import React, { forwardRef } from 'react';
import { FormControl, MenuItem } from '@mui/material';
import { getRandomIndex } from 'utils/random';

import { StyledPKDInputLabel, StyledPKDSelect } from './styles';

export const PKDSelect = forwardRef(
  (
    { id = `${getRandomIndex()}`, label, value, onChange, options = [], error },
    ref
  ) => {
    return (
      <FormControl
        fullWidth>
        <StyledPKDInputLabel
          error={error} id={id} data-testid={'input-label'}>
          {label}
        </StyledPKDInputLabel>
        <StyledPKDSelect
          labelId={id}
          id={`${getRandomIndex()}`}
          value={value}
          label={label}
          onChange={onChange}
          error={error}
          ref={ref}
          data-testid={'pkd-select'}>
          {options?.map((option) => (
            <MenuItem
              key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </StyledPKDSelect>
      </FormControl>
    );
  }
);
